const esgRoutes = [
	{
		path: '/esg',
		name: 'esg-default',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'dashboard' },
		meta: {
			name: 'ESG Dashboard',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/dashboard',
		name: 'esg-dashboard',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'dashboard' },
		meta: {
			name: 'ESG Dashboard',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/materiality',
		name: 'esg-materiality',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'materiality' },
		meta: {
			name: 'ESG Materiality',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/data',
		name: 'esg-data',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'data' },
		meta: {
			name: 'ESG Data Points',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/calculators/dashboard',
		name: 'esg-calculators-dashboard',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'calculators', scene: 'dashboard' },
		meta: {
			name: 'ESG Calculators',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app', 'use.apps.esg.app'],
		},
	},

	{
		path: '/esg/calculators',
		name: 'esg-calculators',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'calculators', scene: 'dashboard' },
		meta: {
			name: 'ESG Calculators',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app', 'use.apps.esg.app'],
		},
	},

	{
		path: '/esg/calculators/energy',
		name: 'esg-calculators-energy',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'calculators', scene: 'energy' },
		meta: {
			name: 'ESG Energy Calculator',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app', 'use.apps.esg.app'],
		},
	},

	{
		path: '/esg/calculators/water',
		name: 'esg-calculators-water',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'calculators', scene: 'water' },
		meta: {
			name: 'ESG Water Calculator',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app', 'use.apps.esg.app'],
		},
	},

	{
		path: '/esg/calculators/waste',
		name: 'esg-calculators-waste',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'calculators', scene: 'waste' },
		meta: {
			name: 'ESG Waste Calculator',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app', 'use.apps.esg.app'],
		},
	},

	{
		path: '/esg/calculators/employees',
		name: 'esg-calculators-employees',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'calculators', scene: 'employees' },
		meta: {
			name: 'ESG Employees Calculator',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app', 'use.apps.esg.app'],
		},
	},

	{
		path: '/esg/calculators/packaging',
		name: 'esg-calculators-packaging',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'calculators', scene: 'packaging' },
		meta: {
			name: 'ESG Packaging Calculator',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app', 'use.apps.esg.app'],
		},
	},

	{
		path: '/esg/admin',
		name: 'esg-admin',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'admin' },
		meta: {
			name: 'ESG Admin',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/admin/dashboard',
		name: 'esg-admin-dashboard',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'admin', scene: 'dashboard' },
		meta: {
			name: 'ESG Admin Dashboard',
		},
	},

	{
		path: '/esg/admin/data',
		name: 'esg-admin-data',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'admin', scene: 'data' },
		meta: {
			name: 'ESG Data Definition',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/admin/entities',
		name: 'esg-admin-entities',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'admin', scene: 'entities' },
		meta: {
			name: 'ESG Entities',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/admin/audit',
		name: 'esg-admin-audit',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'admin', scene: 'audit' },
		meta: {
			name: 'ESG Audit',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},

	{
		path: '/esg/admin/users',
		name: 'esg-admin-users',
		component: () => import('@/apps/esg/Home.vue'),
		props: { view: 'admin', scene: 'users' },
		meta: {
			name: 'ESG Users',
			permissions: ['admin.apps.esg.app', 'manage.apps.esg.app'],
		},
	},
]

export default esgRoutes
